import { Link } from "react-router-dom";

const nav = [
  { to: "/services", label: "Services" },
  { to: "/solutions", label: "Solutions" },
  { to: "/work", label: "Work" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const services = [
  "Website Development",
  "Custom Software",
  "Automation & AI",
  "Digital Transformation",
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14 md:py-16">
        <div className="mx-auto max-w-[1280px] grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-code-s-slash-line text-foreground-950 text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
                EMCHON TECHNOLOGIES
              </span>
            </div>
            <p className="mt-4 text-foreground-600 text-sm leading-relaxed max-w-sm">
              Digital solutions for businesses and organizations ready to move
              forward.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              Navigation
            </h4>
            <ul className="mt-4 space-y-3">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              Services
            </h4>
            <ul className="mt-4 space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <Link
                    to="/services"
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mx-auto max-w-[1280px] mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 EMCHON TECHNOLOGIES. All rights reserved.
          </p>
          <a
            href="mailto:info@emchontechnologies.com"
            className="text-xs text-foreground-500 hover:text-primary-600 transition-colors"
          >
            info@emchontechnologies.com
          </a>
        </div>
      </div>
    </footer>
  );
}